import type { FC } from 'react'

import useGetObjectPage from '@app/hooks/useGetObjectPage'
import List from '@app/pages/strategies/list'

const MapsSectionContent: FC = () => {
  const { collection, metadata } = useGetObjectPage('strategy')

  return <List collection={collection} metadata={metadata} movable />
}

export default MapsSectionContent
